// React imports
import React, { useEffect, useState, Suspense } from 'react';
import { useNavigate } from 'react-router-dom';

// React three Fiber
import { Canvas } from '@react-three/fiber';

// Images
import hepatiteTitle from '/hepatite-title.png';
import surtableTitle from '/surtable-title.png';

// Lazy loading d'un composant
const Scene = React.lazy(() => import('../components/Scene'));

const Home = () => {
    const [isVisible, setIsVisible] = useState(false);
    const navigate = useNavigate();

    // Animation de sortie de la page
    useEffect(() => {
        setIsVisible(true);
        window.setTimeout(() => {
            navigate('/accueil');
        }, 2200);
    }, [navigate]);

    // Style du canvas
    const Style = {
        width: '100%',
        height: '100%',
        top: '0',
    };

    return (
        <div className='homeWrapper'>
            <img
                src={hepatiteTitle}
                className={`homeLogoText ${isVisible ? 'visible' : ''}`}
            />
            <img
                src={surtableTitle}
                className={`homeImage ${isVisible ? 'visible' : ''}`}
            />
            <Suspense fallback={null}>
                <Canvas
                    camera={{
                        fov: 65,
                        near: 0.1,
                        far: 200,
                        position: [0, 18, 0],
                    }}
                    style={Style}
                >
                    {/* <Environment preset='lobby' /> */}
                    <ambientLight intensity={3} />
                    {/* <spotLight
                        position={[0, 10, 0]}
                        intensity={200}
                    /> */}

                    <Scene />
                </Canvas>
            </Suspense>
        </div>
    );
};

export default Home;
